import { i18n } from 'i18n';

export interface CylinderBreakingTestParams extends Record<string, string | undefined> {
  pourId: string;
  breakingScheduleId: string;
  day: string;
}

export const POUR_PARAM_IDENTIFIER = ':pourId';
export const BREAKING_SCHEDULE_PARAM_IDENTIFIER = ':breakingScheduleId';
export const DAY_PARAM_IDENTIFIER = ':day'; // the number of the cylinder based on the time submitted

// eslint-disable-next-line max-len
export const ROUTE_PATH = `/qaqc/${POUR_PARAM_IDENTIFIER}/breaking-schedules/${BREAKING_SCHEDULE_PARAM_IDENTIFIER}/day/${DAY_PARAM_IDENTIFIER}`;
export const TITLE = i18n._('Cylinder Breaking Test');
